import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import seeqLogoDarkBlueSm from 'resources/img/Seeq_logo_darkBlue_sm.png';
import { getWorkbooksLink } from '@/main/routing.utilities';

export const Unauthorized = () => {
  const { t } = useTranslation();
  const ownerInfo = useLocation()?.state?.ownerInfo || {};

  return (
    <div
      data-testid="unauthorizedPage"
      className="flexColumnContainer flexCenter fullViewport splashScreen tw:text-black">
      <div className="container ml0 mr0">
        <div className="row flexJustifyCenter">
          <div className="span12">
            <div data-testid="mainContent" className="jumbotron text-center">
              <p>
                <img src={seeqLogoDarkBlueSm} />
              </p>
              <h2 className="mb10">{t('UNAUTHORIZED.TITLE')}</h2>
              <p>{t('UNAUTHORIZED.DESCRIPTION')}</p>
              <p>
                {ownerInfo && ownerInfo.name
                  ? t('UNAUTHORIZED.CONTACT_SPECIFIC_OWNER', { owner: ownerInfo.name, email: ownerInfo.email })
                  : t('UNAUTHORIZED.CONTACT_OWNER')}
              </p>
              <p>
                <Link to={getWorkbooksLink()}>{t('UNAUTHORIZED.WORKBOOK_OVERVIEW')}</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
